import React from 'react'
import { FieldErrors } from 'react-hook-form'
import get from 'lodash/get'
import ControlledTextField from 'transfix-form/components/ControlledTextInput'
import { Button } from 'transfix-ui/components/Button'
import { makeStyles } from 'transfix-ui/core/styles'
import { useBuilderInvoicesForm } from '../../hooks/useBuilderInvoicesForm'
import { TBuilderInvoicesFormSchema } from './BuilderInvoicesFormSchema'

const getErrorMessage = <T extends FieldErrors<TBuilderInvoicesFormSchema>, K extends keyof T>(
  errors: T,
  keyName: K
): string | undefined => {
  return get(errors, [keyName, 'message'])
}

export interface IBuilderInvoicesFormProps {
  /**
   * @default {}
   */
  defaultValues?: Partial<TBuilderInvoicesFormSchema>
  onSubmit: (options: TBuilderInvoicesFormSchema) => void
  loading: boolean
}

const useBuilderInvoicesFormStyles = makeStyles(theme => ({
  btn: {
    marginTop: theme.spacing(2),
  },
}))

export const BuilderInvoicesForm = ({
  defaultValues = {},
  onSubmit,
  loading,
}: IBuilderInvoicesFormProps) => {
  const { control, errors, handleSubmit } = useBuilderInvoicesForm({
    defaultValues,
  })

  const classes = useBuilderInvoicesFormStyles()

  const submitHandler = handleSubmit((data: TBuilderInvoicesFormSchema) => {
    onSubmit(data)
  })

  return (
    <form onSubmit={submitHandler} data-test='BuilderInvoicesForm'>
      <ControlledTextField
        name='shipmentId'
        control={control}
        defaultValue={defaultValues?.shipmentId}
        TextInputProps={{
          label: 'Shipment ID',
          type: 'string',
          validationMessage: getErrorMessage(errors, 'shipmentId'),
          error: !!getErrorMessage(errors, 'shipmentId'),
          dataTest: 'shipmentId',
        }}
      />
      <Button
        className={classes.btn}
        type='submit'
        color='primary'
        size='large'
        data-test='submit-button'
        disabled={loading}>
        Load Accounting Invoices
      </Button>
    </form>
  )
}
